import styled from '@emotion/styled';

export const TableRow = styled.div`
  display: table-row;
  width: 100%;
  font-size: 0.875rem;
`;
